/** Display labels for known category slugs (extend as you add categories in Supabase). */
export const ACTION_CATEGORY_LABELS = {
  'waste-reduction': 'Waste reduction',
  transport: 'Transport',
  energy: 'Energy',
  food: 'Food',
  community: 'Community',
};

/** When icon_name has no mapping, show this emoji. */
export const ACTION_ICON_FALLBACK = '🌱';

export const ACTIONS_UI = {
  emptyListText: 'No climate actions are available right now. Please check back later.',
  fetchErrorText: 'Could not load climate actions. Pull to refresh or try again shortly.',
};
